import Material from "../Materials"

export default function Interfloor(params) {
  const sm = <Material material={params.material} type={params.type} texture={params.texture}/> 
  return (
    <group item="interfloor">
      <mesh  
      castShadow
      receiveShadow
      position={[params.size/2, params.dim[2]+params.ceilHeight/2, 0]}>
        {sm}
        <boxGeometry args={[params.size,params.ceilHeight,params.dim[0]]} />
      </mesh>
      <mesh  
      castShadow
      receiveShadow
      position={[params.dim[1]/2, params.dim[2]+params.ceilHeight/2, params.dim[0]/2-params.size/2]}>
        {sm}
        <boxGeometry args={[params.dim[1],params.ceilHeight,params.size]} />
      </mesh>
      <mesh  
      castShadow
      receiveShadow
      position={[params.dim[1]-params.size/2, params.dim[2]+params.ceilHeight/2, 0]}>
        {sm}
        <boxGeometry args={[params.size,params.ceilHeight,params.dim[0]]} />
      </mesh>
      <mesh  
        castShadow
        receiveShadow
        position={[params.dim[1]/2, params.dim[2]+params.ceilHeight/2, -params.dim[0]/2+params.size/2]}>
        {sm}
        <boxGeometry args={[params.dim[1],params.ceilHeight,params.size]} />
      </mesh>
    </group>
  )
}
